var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// `localStorage` key holding the contact the message sound was played for, so
// only one of the agent's open tabs plays it
export var MESSAGE_SOUND_LOCK_KEY = 'messageSoundContactId';
// NIC's default ringtone, shared by incoming calls and text messages
export var NIC_RINGTONE_URL = 'https://max.niceincontact.com/styles/audio/Ring1.wav';
export var mergeByField = function (field, array1, array2) {
    var merged = Array.from(__spreadArray(__spreadArray([], array1, true), array2, true).reduce(function (map, obj) {
        var key = obj[field];
        var existing = map.get(key) || {};
        map.set(key, __assign(__assign({}, existing), obj));
        return map;
    }, new Map())
        .values());
    return merged;
};
